import Vue from 'vue'

export default {

    createMessage(conversation,params=''){
        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.post("conversations/" + conversation + "/messages", params).then((res)=>{                                              
                resolve(res);
            })
        })    
    },        

    getMessages(conversation,params=''){  

        /*
        Get a list of messages.
        Available sort: created_at, updated_at
        */

        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.get("conversations/" + conversation + "/messages" + Vue.prototype.$apiService.getSerializedQuery(params)).then((res)=>{                              
                resolve(res);
            })
        })    
    },

}